import React, {useEffect, useState} from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import L from 'leaflet';
import ClipLoader from 'react-spinners/ClipLoader';


function ConnectionsMap({OriginSelectorValue, destinations, TransportMeansSelection}) {
    const [points2, setpoints2] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state
    const [traffic, setTrafic] = useState([]);

    let url = "";
   
    switch (TransportMeansSelection[0]) {
        case 'Οδικές':
          console.log('This is an Οδικές.');
          break;
        case 'Αεροπορικές':
          url = `/api/airtransport/passenger_movement/?origin=${OriginSelectorValue[0]}&destinations=${destinations}`
          break;
        case 'Θαλάσσιες':
          url = `/api/marinetransport/passenger_movement/?origin=${OriginSelectorValue[0]}&destinations=${destinations}`
          break;
        case 'Σιδηροδρομικές':
          url = `/api/railtransport/passenger_movement/?origin=${OriginSelectorValue[0]}&destinations=${destinations}`
        break;
        default:
          console.log('I do not recognize this link');
      }

      useEffect(() => {
        setLoading(true); // Start loading

        fetch(url).then((res) =>
           res.json().then((res) => {
            
          const reversedPointsArray = res.data.Coordinates.map(points =>
            points.map(point => [point[1], point[0]])
          );
          
          setTrafic(res.data["Επιβατική κίνηση"])
          setpoints2(reversedPointsArray)
          setLoading(false); // Stop loading once data is fetched

            
          })
        )
        .catch((error) => {
          console.log("Refetching data for Origins!")
        });
      }, [url, destinations, OriginSelectorValue]);



      const defaultIcon = L.icon({
        iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
      });

    
    let cnt = -1;

    if(!loading) {
      
      return (
          <div className = "container" style = {{marginBottom: "5%"}}>
              <p style = {{color: "orange"}}>*Για περισσότερες πληροφορίες πατήστε πάνω στο οδικό τμήμα</p>
              <MapContainer center={[37.983810, 23.727539]} zoom={7} scrollWheelZoom={true} style={{height: "500px"}}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                />
                {points2.map((points, index) => {
                  const firstPoint = points[0];
                  const lastPoint = points[points.length - 1];
                  cnt++;
                  return (
                    <div key={index}>
                        <Marker position={firstPoint} icon = {defaultIcon}>
                        <Popup>
                          {OriginSelectorValue[0]}
                        </Popup>
                      </Marker>
                      <Marker position={lastPoint}icon = {defaultIcon} >
                        <Popup>
                          {destinations[index]}
                        </Popup>
                      </Marker>
                      <Polyline pathOptions={{ weight: 5 }} positions={points} color="blue" >
                        <Popup autoClose={false}>
                          <div>
                              <p>Προέλευση: {OriginSelectorValue[0]}</p>
                              <p>Προορισμός: {destinations[cnt]}</p>
                            <p>Επιβατική κίνηση: {traffic[cnt]} </p>
                          </div>
                        </Popup>
                      </Polyline>
                    </div>
                  )
                })}
              </MapContainer>

          </div>
      );
    }
    else {
      return(
        <div className="container" style = {{marginLeft: "40%"}}>
          <ClipLoader size={100} color={'#123abc'} loading={true}/>
        </div>
      )
    }
  };


export default ConnectionsMap;